import * as React from 'react';
import './AccountInfoHeader.scss';
import ArSummaryDesktop from 'src/components/AR-Summary/Desktop';
import ArSummaryMobile from 'src/components/AR-Summary/Mobile';
import { goToInvoices } from 'src/utils/navigation';
import UserModel from 'src/model/user.model';
import LocaleFormating from 'src/translation/localeFormating';
import { canViewInvoices } from 'src/utils/permissions';

interface IAccountInfoHeaderProps {
  userData: UserModel;
  t?: any;
}

export function AccountInfoHeader(props: IAccountInfoHeaderProps) {
  const { t } = props;
  const userName = props.userData
    ? props.userData.name && props.userData.name.length
      ? props.userData.name
      : `#${props.userData.accountId}`
    : '';

  const accountNumber = props.userData ? props.userData.accountId : '';

  const rawBalance =
    props.userData && props.userData.accountCredit
      ? props.userData.accountCredit.balance
      : null;
  const rawLimit =
    props.userData && props.userData.accountCredit
      ? props.userData.accountCredit.creditLimit
      : null;

  const balance = rawBalance
    ? LocaleFormating.formatCurrency(parseFloat(rawBalance))
    : '...';
  const limit = rawLimit
    ? LocaleFormating.formatCurrency(parseFloat(rawLimit))
    : '...';

  return (
    <div className="rp-accountinfoheader">
      <div className="rp-accountinfo--header">
        <div className="container-fluid">
          <div className="rp-accountinfo--header-content">
            <div className="row position-handler">
              <div className="col-6 col-md-3">
                <h1>
                  {t('accountInfoHeader.helloTxt')}, {userName}
                </h1>
              </div>
              <div className="col-6 col-md-3">
                <p className="rp-accountinfo--header-detail">
                  {t('accountInfoHeader.accountNumber')}:{' '}
                  <b className={'rp--header-detail--break-line'}>
                    {accountNumber}
                  </b>
                </p>
              </div>
              {canViewInvoices() && (
                <div className="col-6 col-md-3">
                  <div className="rp-accountinfo--header-detail rp-credit-limit-text d-flex flex-column flex-lg-row">
                    <p className="rp-accountinfo--header-detail-space">
                      {t('accountInfoHeader.creditLimit')}:{' '}
                    </p>
                    <b className={'rp--header-detail--break-line'}>{limit}</b>
                  </div>
                </div>
              )}
              <div className="col-6 col-md-3">
                <div className="rp-accountinfo--btn-container">
                  <button style={{width: "73%"}} 
                    className="rp-accountinfo--btn primary-button"
                    onClick={goToInvoices}
                  >
                    {t('accountInfoHeader.viewPayInvoices')}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid rp-accountinfo--header-content--desktop">
            <ArSummaryDesktop renderColumnType="wide" />
          </div>
          <div className="container-fluid rp-accountinfo--header-content--mobile">
            <ArSummaryMobile renderType={'accountSetting'} />
          </div>
        </div>
      </div>
    </div>
  );
}
